import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { isMobileStyleMixin } from '@amzn/storm-ui';

const activeStyles = /*#__PURE__*/css(["border-color:", ";background-color:", ";font-weight:bold;a,p{font-weight:normal;}"], ({
  theme
}) => theme.button.toggleArea.borderColorActive, ({
  theme
}) => theme.button.toggleArea.bgActive);
const normalStyles = /*#__PURE__*/css(["border-color:", ";background-color:", ";:hover{background:", ";}"], ({
  theme
}) => theme.button.toggleArea.borderColor, ({
  theme
}) => theme.button.toggleArea.bg, ({
  theme
}) => theme.button.toggleArea.bgHover);
const labelContainerBorderRadius = /*#__PURE__*/css(["border-radius:", ";"], ({
  theme
}) => theme.button.toggleArea.borderRadius);
const StyledToggleArea = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30062554__sc-16lha07-0"
})(["cursor:", ";", ";padding-block-start:6px;padding-block-end:6px;padding-inline-start:18px;padding-inline-end:18px;display:flex;align-items:center;justify-content:center;", " border:1px solid ", ";color:", ";cursor:", ";text-align:center;vertical-align:middle;@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease;}", " ", " ", ""], ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', ({
  theme
}) => theme.typography.base, labelContainerBorderRadius, ({
  theme
}) => theme.button.borderColor, ({
  theme
}) => theme.button.toggleArea.color, ({
  theme
}) => theme.button.cursor, isMobileStyleMixin(css(["padding:", ";font-size:", ";"], ({
  theme
}) => theme.button.toggleArea.padding, ({
  theme
}) => theme.button.normal.mobile.fontSize)), ({
  $checked
}) => $checked ? activeStyles : normalStyles, ({
  disabled
}) => disabled && css(["pointer-events:all;cursor:not-allowed;outline:none;opacity:1;color:", ";:hover{background:", ";}"], ({
  theme
}) => theme.typography.color.tertiary, ({
  theme
}) => theme.button.toggleArea.bg));
StyledToggleArea.displayName = 'StyledToggleArea';
function LabelContainer({
  checked,
  disabled,
  label,
  ...restProps
}) {
  return /*#__PURE__*/React__default.createElement(StyledToggleArea, _extends({}, restProps, {
    $checked: checked,
    disabled: disabled
  }));
}

export { LabelContainer as L, labelContainerBorderRadius as l };
//# sourceMappingURL=LabelContainer-B-AAu4SJ.js.map
